import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Dashboard from '../pages/Dashboard';
import PublicProfile from '../pages/PublicProfile';

const UserRouter: React.FC = () => {
  const { username } = useParams<{ username: string }>();
  const { currentUser, isAuthenticated } = useAuth();

  // If user is authenticated and viewing their own profile, show dashboard
  if (isAuthenticated() && currentUser && currentUser.username === username) {
    return <Dashboard />;
  }

  // Otherwise, show public profile
  return <PublicProfile />;
};

export default UserRouter;